import { eventSchedulerValidator } from "../../../quotes/quote-create-stepper/next-prev/validators/eventSchedulerValidator";
import { EMode } from "../../../shared/components/features/event-scheduler/enums/event.enums";
import { validateScopeOfWorkByMode } from "./scope-of-work/validateScopeOfWorkByMode";
import { resolveJobEventSchedulerPayload } from "./resolveJobEventScheduler";

export type JobCreateState = {
  client?: string | { uid?: string; coverageArea?: { id?: string | number; [key: string]: any } };
  scopeOfWork?: any;
  quote?: any;
  eventScheduler?: any;
  selectedService?: { service?: { eventPreferences?: unknown; serviceUid?: string }; serviceUid?: string };
  quoteMode?: string;
  workforce?: { employees?: Array<any>; contractors?: Array<any>; supervisors?: Array<any> };
};

type ValidatorResult = boolean | string;
type ValidatorFn = (state: JobCreateState) => ValidatorResult;

export const JOB_CREATE_VALIDATORS: Record<string, ValidatorFn> = {
  client: (state) => {
    // if (!state?.client) return "You must select a client";
    if (typeof state.client === "string") return true; // String UID is valid
    // if (!state.client.uid) return "You must select a client";
    return true;
  },

  "quote-mode": (state) => {
    const mode = state?.quoteMode;

    if (mode !== "basic" && mode !== "advanced") {
      return "You must select a service mode";
    }

    return true;
  },
  "client-coverage": (state) => {
    if (!state?.client) return "You must select a client";
    if (typeof state.client === "string") return "You must select a client";
    if (!state.client.coverageArea) return "You must select a coverage area";
    if (!state.client.coverageArea.id) return "You must select a coverage area";
    return true;
  },

  "client-address": (state) => {
    if (!state?.client || typeof state.client === "string" || !state.client.coverageArea?.id) {
      return "You must select an address";
    }
    return true;
  },

  "scope-of-work": validateScopeOfWorkByMode,

  quote: (state) => {
    if (!state?.quote) return "Please select a quote";
    const serviceUid = state.selectedService?.service?.serviceUid || state.selectedService?.serviceUid || state.quote?.services?.[0]?.serviceUid;
    if (!serviceUid) return "Please select a service from the quote";
    return true;
  },

  time: (state) => {
    const sched = resolveJobEventSchedulerPayload(state);
    if (!sched) return "You must schedule an event";

    const nested = sched.eventPreferences as { eventConfig?: { mode?: string } } | undefined;
    const mode = nested?.eventConfig?.mode ?? (sched.eventConfig as { mode?: string } | undefined)?.mode;

    if (mode === EMode.CONFIGURE_LATER || mode === "CONFIGURE_LATER") return true;

    const forValidator = sched.eventPreferences != null && typeof sched.eventPreferences === "object" ? sched : { eventPreferences: sched };

    const result = eventSchedulerValidator(forValidator);
    return result === true ? true : "Invalid event schedule";
  },

  workforce: (state) => {
    const wf = state.workforce;

    if (!wf) return "You must assign at least one worker";

    const hasEmployees = Array.isArray(wf.employees) && wf.employees.length > 0;
    const hasContractors = Array.isArray(wf.contractors) && wf.contractors.length > 0;
    const hasSupervisors = Array.isArray(wf.supervisors) && wf.supervisors.length > 0;

    if (!hasEmployees && !hasContractors && !hasSupervisors) {
      return "You must assign at least one worker";
    }

    return true;
  },

  none: () => true,
};
